import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogComponent } from './components/dialog/dialog.component';
import { DialogService } from './service/dialog.service';
import { ButtonModule } from '../../../common/button/button.module';
import { CloseBtnModule } from '../../../common/close-btn/close-btn.module';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [DialogComponent],
  providers: [DialogService],
  imports: [
    CommonModule,
    CloseBtnModule,
    ButtonModule,
    MatDialogModule
  ],
  exports: [DialogComponent]
})
export class DialogModule { }
